import { MdCheck, MdClose, MdDraw } from "react-icons/md";
import { useState } from "react";
import Modal from "../Modal/Modal";
import tasksStore from "../../store/tasksStore";

import { useTranslation } from "react-i18next";
import { showNotification } from "../../helpers/utils";
import useNotes from "../../hooks/useNotes";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import modalsStore from "../../store/modalsStore";
import TextAreaInput from "../TextAreaInput/TextAreaInput";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

interface INewTaskModal {
  onClose?: () => void;
  onCreated?: (e: any) => void;
}

const NewTaskModal: React.FC<INewTaskModal> = ({
  onClose = () => {},
  onCreated = () => {},
}) => {
  const [isAddingTask, setIsAddingTask] = useState<boolean>(false);
  const [task, setTask] = useState<string>("");
  const { setShowCreateNewCanvas } = modalsStore();
  const { addTask, getTasks } = tasksStore();
  const { t } = useTranslation(["common"]);
  const { resetCache } = useNotes();

  return (
    <>
      <Modal
        width="md:min-w-[600px]"
        onEscape={() => {
          if (!isAddingTask) {
            onClose();
          }
        }}
      >
        <Modal.Header
          title={t("notes.add_note_title")}
          onClose={() => {
            if (!isAddingTask) {
              onClose();
            }
          }}
        />
        <Modal.Body>
          <form
            id="create-task"
            onSubmit={async (e) => {
              e?.preventDefault?.();
              setIsAddingTask(true);

              await addTask({
                onError: (e) => {
                  setIsAddingTask(false);
                  showNotification({
                    message: t("notes.error_adding_note"),
                    kind: "error",
                  });
                },
                content: task,
                onResolved: async (e) => {
                  setIsAddingTask(false);
                  showNotification({
                    message: t("notes.note_added_message"),
                    kind: "success",
                  });
                  setTask("");
                  await resetCache();
                  onClose();
                },
              });
            }}
          >
            <div className="flex flex-col gap-4">
              <TextAreaInput
                required
                rows={6}
                disabled={isAddingTask}
                placeholder={t("notes.add_note_placeholder")}
                onChange={(e) => setTask(e?.target?.value)}
                value={task}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer
          actions={[
            {
              text: t("common:buttons.save"),
              onClick: () => {},
              kind: EButtonKind.SAVE,
              icon: <MdCheck size={ICON_SIZES.SM} />,
              type: "submit",
              form: "create-task",
              disabled: isAddingTask,
              isLoading: isAddingTask,
            },
            {
              text: t("common:buttons.close"),
              onClick: () => onClose(),
              kind: EButtonKind.NORMAL,
              icon: <MdClose size={ICON_SIZES.SM} />,
              disabled: isAddingTask,
            },
          ]}
          leftContent={
            <ButtonGroup
              align="left"
              buttons={[
                {
                  icon: <MdDraw size={ICON_SIZES.SM} />,
                  onClick: () => {
                    onClose?.();
                    setShowCreateNewCanvas(true);
                  },
                },
              ]}
              gap={1}
            />
          }
        />
      </Modal>
    </>
  );
};

export default NewTaskModal;
